import { AddressDisplay } from './AddressDisplay'

// The address display renderer, lifted verbatim — the identical body sat in
// OrderAddressInlineInput.tsx, LogisticAddressInlineInput.tsx and
// PurchaseOrderAddressInlineInput.tsx (`code-rule.md` → "DRY — Rule of Two"). Named
// `addressDisplayValue` (not `addressDisplayContent`) to avoid colliding, on a case-insensitive
// filesystem, with the pre-existing `AddressDisplayContent.tsx` in this same folder.
export const addressDisplayValue = (value: any) => <AddressDisplay value={value} />
